import { CellProps } from 'react-table'
import { LogsConsultaActionsCell } from './LogsConsultaActionsCell'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { TFunction } from '_metronic/i18n/Metronici18n'
import { AtendimentoList } from 'app/modules/apps/atendimento/core/_models'
import { PlainHeader, sortableColumn, StackedCell, TableColumn } from 'app/components'

export const LogsConsultaColumns = (t: TFunction): ReadonlyArray<TableColumn<AtendimentoList>> => [
  // Paciente com o protocolo como apoio; os dois seguem ordenáveis.
  sortableColumn<AtendimentoList>({
    id: 'paciente.pessoa.nome',
    useQueryRequest,
    fields: [
      { field: 'paciente.pessoa.nome', label: t('cols.paciente') },
      { field: 'protocolo', label: t('cols.protocolo') },
    ],
    Cell: ({ row }: CellProps<AtendimentoList>) => (
      <StackedCell primary={row.original.paciente?.nome} secondary={row.original.protocolo} />
    ),
  }),
  sortableColumn<AtendimentoList>({
    id: 'responsavel.pessoa.nome',
    hideOnMobile: true,
    useQueryRequest,
    fields: [{ field: 'responsavel.pessoa.nome', label: t('cols.responsavel') }],
    Cell: ({ row }: CellProps<AtendimentoList>) => (
      <StackedCell primary={row.original.responsavel?.nome} />
    ),
  }),
  sortableColumn<AtendimentoList>({
    id: 'solicitacao',
    cellWidth: '170px',
    hideOnMobile: true,
    useQueryRequest,
    fields: [{ field: 'solicitacao', label: t('cols.agendamento') }],
    Cell: ({ row }: CellProps<AtendimentoList>) => (
      <StackedCell tabular primary={row.original.solicitacaoFormatada} />
    ),
  }),
  {
    Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
    id: 'actions',
    cellWidth: '96px',
    align: 'end',
    Cell: ({ row }: CellProps<AtendimentoList>) => (
      <LogsConsultaActionsCell atendimento={row.original} />
    ),
  },
]
